// extracted by mini-css-extract-plugin
export default {"logo":"MAmM7","logoImage":"UCyQB","sizeS":"bdcDb","sizeM":"ESymL","sizeL":"GCi9r"};